import * as types from './action_types';
import PeopleSearcher from '../../services/people_searcher';
import AccountMapper from '../utils/account_mapper';

export const search = (peopleText) => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.PEOPLE_SEARCHING });
      const suggestedPeopleData = await PeopleSearcher.search(peopleText);
      const suggestedPeople = []
      for (let suggestedPerson of suggestedPeopleData) {
        suggestedPeople.push(AccountMapper.map(suggestedPerson));
      }
      dispatch({ type: types.PEOPLE_SEARCHED, suggestedPeople });
    } catch(error) {
      dispatch({ type: types.PEOPLE_SEARCH_ERROR, error });
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/people_search/actions.js